/**
 * A mixin to publish/unpublish Content, used in the SpotDetail page.
 *
 * Work for TV by passing the bundle.main_tvspot.
 */
var contentPublishing = {
  methods: {
    /**
     * Set content (either a Radio- or TVSpot) to published = true.
     */
    publishContent(content) {
      const promise = this.$api.publishContent(content.ctype, content.id);
      promise
        .then(() => {
          this.$bus.$emit('alert-success', {
            message: 'entryUpdatedSuccess',
            translate: true,
          });
        })
        .catch((error) => {
          this.$bus.$emit('alert-error', {
            message: 'genericFailedInfo',
            translate: true,
          });
        });
      return promise;
    },
    /**
     * Set content (either a Radio- or TVSpot) to published = false.
     *
     * Also deletes all existing SpotEntries for that content.
     */
    unpublishContent(content) {
      const promise = this.$api.unpublishContent(content.ctype, content.id);
      promise
        .then(() => {
          this.$bus.$emit('alert-success', {
            message: 'entryUpdatedSuccess',
            translate: true,
          });
        })
        .catch((error) => {
          this.$bus.$emit('alert-error', {
            message: 'genericFailedInfo',
            translate: true,
          });
        });
      return promise;
    },
    showPublishDialog() {
      const vm = this;
      const hint = this.$t('publishContentHint');
      this.$bus.$emit('show-dynamic-dialog', {
        title: this.$t('publishContent'),
        titleIcon: 'visibility',
        content: `
					<div class="subheading">
						${hint}
					</div>
				`,
        onConfirm() {
          const dialog = this;
          dialog.loading = true;
          vm.publishContent(vm.spot).then(() => {
            dialog.loading = false;
            vm.$bus.$emit('hide-dynamic-dialog');
            vm.loading = true;
            vm.fetchContent().then(() => {
              vm.loading = false;
            });
          });
        },
      });
    },
    showUnpublishDialog() {
      const vm = this;
      const hint1 = this.$t('unpublishContentHint_1');
      const hint2 = this.$t('unpublishContentHint_2');
      this.$bus.$emit('show-dynamic-dialog', {
        title: this.$t('unpublishContent'),
        titleIcon: 'visibility_off',
        content: `
					<div class="subheading">
						${hint1}
						<div class="error--text mt-2 pa-2">
							<strong>${hint2}</strong>
						</div>
					</div>
				`,
        onConfirm() {
          const dialog = this;
          dialog.loading = true;
          vm.unpublishContent(vm.spot).then(() => {
            dialog.loading = false;
            vm.$bus.$emit('hide-dynamic-dialog');
            vm.loading = true;
            vm.fetchContent().then(() => {
              vm.loading = false;
            });
          });
        },
      });
    },
  },
};

export default contentPublishing;



// WEBPACK FOOTER //
// ./src/mixins/contentPublishing.js